const ThirdPartyService = (function(root, doc, undefined) {

    'use strict';

    const isVendorDisabled = () => {
        return doc.documentElement.getAttribute('data-vendor') === 'false';
    };

    return {
        isVendorDisabled: isVendorDisabled
    };

})(window, document);

module.exports = ThirdPartyService;
